module.exports = __webpack_public_path__ + "img/zhuanli5.18ffaf6b.png";